import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

interface CategoryTabsProps {
  activeSlug?: string;
  variant?: 'default' | 'hero';
}

export default function CategoryTabs({ activeSlug, variant = 'default' }: CategoryTabsProps) {
  return (
    <div className={`flex flex-wrap gap-2 ${variant === 'hero' ? 'justify-center' : ''}`}>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : variant === 'hero'
                ? 'bg-background-50/80 text-foreground-700 hover:bg-background-50 hover:text-primary-600'
                : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
          }`}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className={`${cat.icon} text-sm`}></i>
          </span>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}